import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle = {
    position: 'absolute',
    width: '100%',
    height: 40,
    transform: 'translate(0%, -50%)',
    borderRadius: 0,
    cursor: 'pointer',
    // border: '1px solid white',
}

const railInnerStyle = {
    position: 'absolute',
    width: '100%',
    height: 40,
    transform: 'translate(0%, -50%)',
    borderRadius: 0,
    pointerEvents: 'none',
    backgroundColor: "#eeeeee",
}

export function SliderRail({ getRailProps }) {
    return (
        <Fragment>
            <div style={railOuterStyle} {...getRailProps()} />
            <div style={railInnerStyle} />
        </Fragment>
    )
}

SliderRail.propTypes = {
    getRailProps: PropTypes.func.isRequired,
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
export function Handle({
    domain: [min, max],
    handle: { id, value, percent },
    length,
    disabled,
    getHandleProps
}) {
    const width = Math.min((length / max) * 100, 100)
    if (percent > 100 - (width / 2)) percent = 100 - (width / 2)
    if (percent < width / 2) percent = width / 2
    if (percent > 100) percent = 100

    return (
        <Fragment>
            <div
                style={{
                    left: `${percent}%`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 5,
                    width: `${width}%`,
                    height: 40,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                    opacity: 0.6,
                }}
                {...getHandleProps(id)}
            />
            <div // 좌측 중앙 핸들
                style={{
                    left: `calc(${percent}% - ${width / 2}%)`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 6,
                    width: 3,
                    height: 40,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                }}
                {...getHandleProps(id)}
            />
            <div // 좌측 상단 핸들
                style={{
                    left: `calc(${percent}% - ${width / 2}% + 3px)`,
                    top: `-19.5px`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 6,
                    width: 8,
                    height: 3,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                }}
                {...getHandleProps(id)}
            />
            <div // 좌측 하단 핸들
                style={{
                    left: `calc(${percent}% - ${width / 2}% + 3px)`,
                    bottom: `-23px`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 6,
                    width: 8,
                    height: 3,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                }}
                {...getHandleProps(id)}
            />
            
            <div // 우측 상단 핸들
                style={{
                    left: `calc(${percent}% + ${width / 2}% - 3px)`,
                    top: `-19.5px`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 6,
                    width: 8,
                    height: 3,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                }}
                {...getHandleProps(id)}
            />
            <div // 우측 하단 핸들
                style={{
                    left: `calc(${percent}% + ${width / 2}% - 3px)`,
                    bottom: `-23px`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 6,
                    width: 8,
                    height: 3,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                }}
                {...getHandleProps(id)}
            />
            <div // 우측 중앙 핸들
                style={{
                    left: `calc(${percent}% + ${width / 2}%)`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 6,
                    width: 3,
                    height: 40,
                    cursor: 'pointer',
                    backgroundColor: '#ff8f44',
                }}
                {...getHandleProps(id)}
            />
        </Fragment>
    )
}

Handle.propTypes = {
    domain: PropTypes.array.isRequired,
    handle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    getHandleProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

Handle.defaultProps = {
    disabled: false,
}

// *******************************************************
// KEYBOARD HANDLE COMPONENT
// Uses a button to allow keyboard events
// *******************************************************
export function KeyboardHandle({
    domain: [min, max],
    handle: { id, value, percent },
    disabled,
    getHandleProps,
}) {
    return (
        <button
            role="slider"
            aria-valuemin={min}
            aria-valuemax={max}
            aria-valuenow={value}
            style={{
                left: `${percent}%`,
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                zIndex: 2,
                width: 36,
                height: 36,
                borderRadius: '50%',
                boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
                backgroundColor: disabled ? '#666' : '#ffc400',
            }}
            {...getHandleProps(id)}
        />
    )
}

KeyboardHandle.propTypes = {
    domain: PropTypes.array.isRequired,
    handle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    getHandleProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

KeyboardHandle.defaultProps = {
    disabled: false,
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
export function Track({ source, target, getTrackProps, disabled }) {
    return (
        <div
            style={{
                position: 'absolute',
                transform: 'translate(0%, -50%)',
                height: 40,
                zIndex: 1,
                backgroundColor: disabled ? '#999' : '#8dc223',
                borderRadius: 0,
                cursor: 'pointer',
                left: `${source.percent}%`,
                width: `${target.percent - source.percent}%`,
            }}
            {...getTrackProps()}
        />
    )
}

Track.propTypes = {
    source: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    target: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    getTrackProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

Track.defaultProps = {
    disabled: false,
}

// *******************************************************
// TICK COMPONENT
// *******************************************************
export function Tick({ tick, count, format }) {
    return (
        <div>
            <div
                style={{
                    position: 'absolute',
                    marginTop: 14,
                    width: 1,
                    height: 5,
                    backgroundColor: 'rgb(200,200,200)',
                    left: `${tick.percent}%`,
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    marginTop: 22,
                    fontSize: 10,
                    textAlign: 'center',
                    marginLeft: `${-(100 / count) / 2}%`,
                    width: `${100 / count}%`,
                    left: `${tick.percent}%`,
                }}
            >
                {format(tick.value)}
            </div>
        </div>
    )
}

Tick.propTypes = {
    tick: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    count: PropTypes.number.isRequired,
    format: PropTypes.func.isRequired,
}

Tick.defaultProps = {
    format: d => d,
}